import React, { useState, useEffect } from "react";
import Styles from './index'
import * as Typography from './typography'
import { StyleSheet, Image, View, ScrollView, FlatList, ListItem, TouchableOpacity } from "react-native";
import { Container, ImageBackground,  Header,  Title,  Button,  
    DeckSwiper, Card,  CardItem,  Icon,  Thumbnail,  Text,  Left,  Right,  Body, 
    Footer, Grid, Col, Row, H1, H2, H3, Item } from "native-base";


// displays either a solid or open bookmark based on prop
export const Bookmark = (props) => (
    props.bookmarked == true ? (
        <Icon name='bookmark' type='FontAwesome' style={{color:Styles.Colors.colorPalette.Dark}} />
    ) : (
        <Icon name='bookmark-o' type='FontAwesome' style={{color:Styles.Colors.colorPalette.Dark}} />
    )
)

export const BookmarkAction = ({bookmarked = false, style={}, onPress }) => {
   
    const [bookmarkState, setBookmarkState] = useState(bookmarked)
    
    return(
        bookmarkState == true ? (
            <TouchableOpacity onPress={onPress} >
                <Icon name='bookmark' type='FontAwesome' style={style, {color:Styles.Colors.colorPalette.Dark}} />
            </TouchableOpacity>
        ) : (
            <TouchableOpacity onPress={onPress} >
                <Icon name='bookmark-o' type='FontAwesome' style={style, {color:Styles.Colors.colorPalette.Dark}} />
            </TouchableOpacity>
        )
    )
}

// displays either a solid or open heart based on prop
export const Heart = (props) => (
    props.favored == true ? (
        <Icon name='heart' type='FontAwesome' style={{color:Styles.Colors.colorPalette.mainColor}} />
    ) : (
        <Icon name='heart-o' type='FontAwesome' style={{color:Styles.Colors.colorPalette.mainColor}} />
    )
)

// a card for displaying a user's profile
export const ProfileCard = (props) => (
    <Card style={Styles.Typography.profileCardContainer.desktop}>
        <CardItem style={{flex:1}}>
            <Left>
                <Thumbnail source={props.image} />
                <Body>
                    <Text style={Styles.Typography.profileCardText.all}>
                        {props.fullName}
                    </Text>
                </Body>
            </Left>
        </CardItem>

        <CardItem cardBody>
        <Image
            style={{
            resizeMode: "cover",
            width: null,
            flex: 1,
            height: 300
            }}
            source={props.image}
        />
        </CardItem>

        <CardItem style={Styles.Typography.profileCardFooter, {backgroundColor: Styles.Colors.colorPalette.White}}>
        
        <Left style={{flex:1}}>
        <Text style={Styles.Typography.profileCardText.all}>

                {props.percentageMatch}
            </Text>
        </Left>

        <Body style={{flex:2, flexDirection:'column', alignItems:'center'}}>
            {/* <Text numberOfLines={1}>{card.fullName}</Text> */}
            <Text style={Styles.Typography.profileCardText.all}>

                {props.gender}
            </Text>
            <Text style={Styles.Typography.profileCardText.all}>
                Age: {props.age}
            </Text>
        </Body>

        <Right style={{flex:1}}>
            <Styles.Components.Heart favored={props.favored} />
        </Right>

        </CardItem>
              
    </Card>
)

// new profile card 
export const ProfileCardSlim = (props) => (
    
        <View style={props.displayDesktop ? Typography.profileCard.container : Typography.profileCard.containerMobile}>
            {/* card header */}
            <View style={Typography.profileCard.headerContainer}>
                <Text style={Typography.profileCard.headerText}>
                    {props.fullName}
                </Text>
            </View>

            {/* card body */}
            <TouchableOpacity 
                onPress={props.onPress}
                style={Typography.profileCard.bodyContainer}>
                <Image 
                    style={props.displayDesktop ? Typography.profileCard.imageContainer : Typography.profileCard.imageContainerMobile}
                    source={props.image}
                />
            </TouchableOpacity>

            {/* card footer  */}
            <View style={Typography.profileCard.footerContainer}>
                <View style={Typography.profileCard.footerLeft}>
                    <Text style={Typography.profileCard.footerText}>
                        {props.percentageMatch}
                    </Text>
                </View>
                <View style={Typography.profileCard.footerBody}>
                    <Text style={Typography.profileCard.footerText}>
                        {props.gender}
                    </Text>
                    <Text style={Typography.profileCard.footerText}>
                        Age: {props.age}
                    </Text>
                </View>
                <View style={Typography.profileCard.footerRight}>
                    <Styles.Components.Heart favored={props.favored} />
                </View>
            </View>
        </View>

)


// 
export const FullProfileContainer = (props) => {

    return (
        <>

            <Styles.Components.FullProfileHeader 
                name={props.profileData.name.firstName}
                catchphrase={props.profileData.basicInfo.catchphrase}
                profilePic={props.profilePic}
            />

            <Styles.Components.FullProfilePersonalInfoGroup 
                location={props.profileData.basicInfo.location}
                branch={props.profileData.basicInfo.branchOfServiceAffiliation}
                dutyStatus={props.profileData.basicInfo.dutyStatus}
                currentEmployment={props.profileData.basicInfo.currentEmployment}
                age={props.profileData.basicInfo.age}
                height={props.profileData.basicInfo.height}
                maritalStatus={props.profileData.basicInfo.maritalStatus}
                education={props.profileData.basicInfo.education}
            />
            
            {/* <Styles.Components.ProfilePicViewer 
            profilePics={profilePics}
            picCount={picCount}
            />  */}

        </>
    )
}

// view for displaying a user's full header profile 
export const FullProfileHeader = (props) => {

    return(
        <View style={Styles.Typography.FullProfileHeaderContainer.all}>
            <H1 style={Styles.Typography.FullProfileGeneral.header}>
                {props.name}
            </H1>

            {props.profilePic ? 
                <Thumbnail large source={props.profilePic} />
            :
                <Icon name='person' style={Styles.Typography.FullProfileGeneral.defaultPicIcon} />
            }

            <H3 style={Styles.Typography.FullProfileGeneral.catchphrase}>
                {props.catchphrase}
            </H3>

        </View>
    )
}

export const FullProfilePersonalInfoGroup = (props) => {

    return(
        <View style={Styles.Typography.FullProfilePersonalInfoGroup.container}  >
            <View style={Styles.Typography.FullProfilePersonalInfoGroup.items}>
                <Text style={Styles.Typography.FullProfileGeneral.text}>
                    Location: {props.location}
                </Text>
                <Text style={Styles.Typography.FullProfileGeneral.text}>
                    Branch: {props.branch}
                </Text>
                <Text style={Styles.Typography.FullProfileGeneral.text}>
                    Duty Status: {props.dutyStatus}
                </Text>
                <Text style={Styles.Typography.FullProfileGeneral.text}>
                    Current Employment: {props.currentEmployment}
                </Text>
            </View>
            <View style={Styles.Typography.FullProfilePersonalInfoGroup.items}>
                <Text style={Styles.Typography.FullProfileGeneral.text}>
                    Age: {props.age}
                </Text>
                <Text style={Styles.Typography.FullProfileGeneral.text}>
                    Height: {props.height}
                </Text>
                <Text style={Styles.Typography.FullProfileGeneral.text}>
                    Marital Status: {props.maritalStatus}
                </Text>
                <Text style={Styles.Typography.FullProfileGeneral.text}>
                    Education: {props.education}
                </Text>
            </View>
        </View>
    )
}



export const ProfilePicViewer = (props) => {

    return(
        <View style={{flex:1, width:'75%'}}>
            <DeckSwiper 
                dataSource={props.profilePics}
                renderItem={picInfo =>
                    <Card style={{elevation:3, flex:1, flexGrow:1 }}>
                        <CardItem>
                            <Left>
                                <Body>
                                    <Text style={Styles.Typography.FullProfileGeneral.text}>
                                        {picInfo.pos} of {props.picCount}
                                    </Text>
                                </Body>
                            </Left>
                        </CardItem>
                        <CardItem cardBody>
                            <Image style={{resizeMode: 'cover', overflow:'visible', flex: 1, flexBasis:10, height:500, width:null }}                               
                                source={picInfo.image}
                            />
                        </CardItem>
                    </Card>
                }
            />      

        </View>
    )
}

export const SavedGridComponent = ({data = []}) => {

    const onPress = () => {
        alert('bookmarked!')
    }

    return(
        <ScrollView contentContainerStyle={Styles.Typography.GridComponentStyling.container}>
            {data.map(row =>
                <View style={Styles.Typography.GridComponentStyling.row}>
                    <View style={Styles.Typography.GridComponentStyling.rowItem}>
                        <BookmarkAction bookmarked={row.bookmarked} style={Styles.Typography.GridComponentStyling.rowItem} onPress={onPress} />
                    </View>         
                    <View style={Styles.Typography.GridComponentStyling.rowItem}>
                        <Heart />
                    </View>                
                </View>
            )}
        </ScrollView>
    )
}   